/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import input from "../../../../assets/styles/components/input.module.css";
import Button from "../../../../components/Button/Button";
import ModalGeneric from "../../../../components/ModalGeneric/ModalGeneric";
import styles from "./Filter.module.css";
import SelectChartOfAccounts from "./SelectChartOfAccounts";
import SelectCostCenter from "./SelectCostCenter";
import SelectFinanceAccount from "./SelectFinanceAccount";

import { type ICashFlowFilters } from "../../../../services/cashFlow";

interface FilterProps {
  dataFilter: ICashFlowFilters;
  setDataFilter: (filter: ICashFlowFilters) => void;
  onClose: () => void;
}

const Filter = ({ setDataFilter, dataFilter: initialFilters, onClose }: FilterProps) => {
  // Estado local para aplicar a busca na URL apenas no clique de "Filtrar"
  const [localFilter, setLocalFilter] = useState<ICashFlowFilters>(initialFilters);

  const handleChange = (value: string | boolean, field: keyof ICashFlowFilters) => {
    setLocalFilter((prev) => ({ ...prev, [field]: value }));
  };

  const handleApplyFilters = () => {
    setDataFilter(localFilter);
    onClose();
  };

  return (
    <ModalGeneric
      onClick={onClose}
      title="Filtros Avançados"
      modalGenericCustom={styles.modalCustom}
    >
      <div className={styles.filter}>
        {/* --- FILTROS DE DATA --- */}
        <div style={{ display: "flex", gap: "10px", flexDirection: "column", marginBottom: "10px" }}>
          <label style={{ fontWeight: "bold" }}>Considerar Data de:</label>
          <select
            className={input.input}
            value={localFilter.tipo_data || "movimentacao"}
            onChange={(e) => handleChange(e.target.value as any, "tipo_data")}
          >
            <option value="movimentacao">Data da Movimentação (Caixa)</option>
            <option value="competencia">Data de Competência</option>
            <option value="vencimento">Data de Vencimento</option>
          </select>

          <div style={{ display: "flex", gap: "10px" }}>
            <label style={{ flex: 1 }}>
              Início
              <input
                className={input.input}
                type="date"
                value={localFilter.inicio || ""}
                onChange={(e) => handleChange(e.target.value, "inicio")}
              />
            </label>
            <label style={{ flex: 1 }}>
              Fim
              <input
                className={input.input}
                type="date"
                value={localFilter.fim || ""}
                onChange={(e) => handleChange(e.target.value, "fim")}
              />
            </label>
          </div>
        </div>

        {/* --- NOVOS FILTROS (STATUS DO FLUXO) --- */}
        <div className={styles.checkboxGroup}>
          <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Situação do Fluxo:</label>
          <div className={styles.checkboxes}>
            <label>
              <input
                type="checkbox"
                checked={!!localFilter.realizado}
                onChange={(e) => handleChange(e.target.checked, "realizado")}
              />
              Realizado
            </label>
            <label>
              <input
                type="checkbox"
                checked={!!localFilter.previsto}
                onChange={(e) => handleChange(e.target.checked, "previsto")}
              />
              Previsto
            </label>
            <label>
              <input
                type="checkbox"
                checked={!!localFilter.incluir_atrasados}
                onChange={(e) => handleChange(e.target.checked, "incluir_atrasados")}
              />
              Incluir Atrasados
            </label>
          </div>
        </div>

        {/* --- OUTROS FILTROS --- */}
        <label style={{ marginTop: "5px" }}>
          Tipo de Lançamento
          <select
            className={input.input}
            value={localFilter.tipo || ""}
            onChange={(e) => handleChange(e.target.value as any, "tipo")}
          >
            <option value="">Todos</option>
            <option value="entrada">Entradas (Receitas)</option>
            <option value="saida">Saídas (Despesas)</option>
          </select>
        </label>

        <SelectFinanceAccount
          handleChangeAccount={(e) => handleChange(e, "conta_financeira")}
          value={localFilter.conta_financeira || ""}
        />

        <SelectChartOfAccounts
          value={localFilter.uid_plano_contas || ""}
          handleChangeChartOfAccount={(value) => handleChange(value, "uid_plano_contas")}
          type="ambos"
        />

        <SelectCostCenter
          value={localFilter.uid_centro_custo || ""}
          handleChangeCostCenter={(value) => handleChange(value, "uid_centro_custo")}
        />

        {/* --- BOTÃO DE APLICAR --- */}
        <Button variant="contain" onClick={handleApplyFilters}>
          Filtrar Lançamentos
        </Button>
      </div>
    </ModalGeneric>
  );
};

export default Filter;